import { formatTokenAmount, removeTrailingZeros } from 'utils/amounts';
import { useAppSelector } from 'redux/use-hooks';
import { selectActiveToken } from 'redux/slices/tokens';

import FungibleTokens from 'services/fungible-tokens';
const { getParsedTokenAmount } = FungibleTokens;

const FRAC_DIGITS = 5;

const amountWithCommas = (amount) => {
  const parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const formatToken = (amount = '0', decimals = 24) => {
  if (amount === null) {
    amount = '0';
  }

  amount = amount.toString();
  if (amount === '0') {
    return amount;
  }

  const formattedAmount = formatTokenAmount(amount, decimals, FRAC_DIGITS);

  if (formattedAmount === `0.${'0'.repeat(FRAC_DIGITS)}`) {
    return `< ${
      !FRAC_DIGITS ? '0' : `0.${'0'.repeat((FRAC_DIGITS || 1) - 1)}1`
    }`;
  }
  return amountWithCommas(removeTrailingZeros(formattedAmount));
};

const TokenAmount = ({ amount }) => {
  const activeToken = useAppSelector(selectActiveToken);

  const getRawAmount = () =>
    getParsedTokenAmount(
      amount,
      activeToken?.onChainFTMetadata?.symbol,
      activeToken?.onChainFTMetadata?.decimals
    );

  return (
    <div className="tamount">
      {getRawAmount() ? (
        formatToken(getRawAmount(), activeToken?.onChainFTMetadata?.decimals)
      ) : (
        <span className="dots" />
      )}
    </div>
  );
};

export default TokenAmount;
